<template>
  <div class="dormitory-container">
    <el-row style="margin-bottom: 0.5rem">
      <span class="title">{{ $t("app.roomType") }}:</span>
      <color-list
        style="margin-right: 60px"
        :color-list="colorList"
        :value="search.roomType"
        @select="updateRoomType"
      ></color-list>
    </el-row>
    <el-row style="margin-bottom: 0.5rem">
      <span class="title">{{ $t("app.bedStatus") }}:</span>
      <color-list
        :color-list="colorListSecond"
        :value="search.bed"
        @select="updateBed"
      ></color-list>
    </el-row>
    <el-row style="margin-bottom: 0.5rem">
      <span class="title">{{ $t("app.studentType") }}:</span>
      <color-list
        style="display: inline-block"
        :color-list="colorListThird"
        :value="search.person"
        @select="updatePerson"
      ></color-list>
    </el-row>
    <el-row style="margin-bottom: 10px">
      <span class="title">{{ $t("app.floor") }}:</span>
      <div style="display: inline-block">
        <el-checkbox-group v-model="search.floorList">
          <el-checkbox
            v-for="floor in floorList"
            :key="floor.code"
            :label="floor.code"
            >{{ floor.name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <el-button
        type="primary"
        size="small"
        style="margin-left: 10px"
        @click="selectReverse"
        >{{ $t("app.invertSelect") }}</el-button
      >
    </el-row>
    <template v-for="i in searchInput">
      <el-input
        :key="i.model"
        v-model="search[i.model]"
        style="width: 160px; margin-right: 10px"
        :placeholder="i.label"
        size="small"
      ></el-input>
    </template>
    <!-- 搜索内容 -->
    <el-cascader
      v-model="search.BedTagsld"
      :props="bbprops"
      size="small"
      style="margin-right: 10px"
      :clearable="true"
    ></el-cascader>
    <el-checkbox
      :label="$t('app.isCheckIn')"
      v-model="search.isCheckIn"
      size="small"
      style="margin-right: 10px"
    >
    </el-checkbox>
    <el-checkbox
      :label="$t('app.isNotCheckout')"
      v-model="search.isCheckOutExpired"
      size="small"
      style="margin-right: 10px"
    >
    </el-checkbox>
    <el-button type="primary" size="small" @click="reset">{{
      $t("app.reset")
    }}</el-button>
    <el-button
      type="primary"
      size="small"
      style="margin-left: 10px"
      @click="selectAll"
      >{{ $t("app.selectAll") }}</el-button
    >
    <el-button
      type="success"
      icon="el-icon-search"
      size="small"
      autofocus
      @click="searchData"
      >{{ $t("app.search") }}</el-button
    >
    <el-select
      style="margin-left: 10px; width: 100px"
      size="small"
      v-model="selectSort"
      placeholder="樓層排序"
      @change="sortChange"
    >
      <el-option
        v-for="item in floorSort"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <br />
    <el-button
      type="success"
      size="small"
      style="margin-top: 10px"
      @click="batchVisible = true"
      :loading="submitting"
      v-show="multipleSelection.length > 0"
      >{{ $t("app.batchCheckIn") }}</el-button
    >
    <el-button
      type="danger"
      size="small"
      style="margin-top: 10px"
      :loading="submitting"
      @click="batchOutVisible = true"
      v-show="multipleSelection.length > 0"
      >{{ $t("app.batchCheckOut") }}</el-button
    >
    <el-button
      type="danger"
      size="small"
      style="margin-top: 10px"
      :loading="submitting"
      @click="batchSetBedTagsVisible = true"
      v-show="multipleSelection.length > 0"
      >{{ $t("app.batchSetBedTags") }}</el-button
    >
    <div class="table-container">
      <el-table
        :data="tableData"
        style="width: 100%; color: black"
        :cell-style="cellStyle"
        @selection-change="handleSelectionChange"
        height="500px"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          align="center"
          width="300px"
          :label="$t('app.operation')"
        >
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="adjust(scope.row)">{{
              $t("app.adjustment")
            }}</el-button>
            <el-button
              size="small"
              type="danger"
              :disabled="
                scope.row.studentNumber === '' ||
                  scope.row.studentNumber === null ||
                  !scope.row.hasCheckIn
              "
              @click="checkOut(scope.row)"
              >{{ $t("app.checkOut") }}</el-button
            >
            <el-button
              size="small"
              :disabled="
                scope.row.hasCheckIn ||
                  scope.row.studentNumber === '' ||
                  scope.row.studentNumber === null
              "
              type="success"
              @click="checkIn(scope.row)"
            >
              {{ scope.row.hasCheckIn ? "已入住" : "check in" }}</el-button
            >
            <el-button
              v-if="scope.row.requirement"
              size="small"
              type="success"
              @click="adjustApplication(scope.row)"
              >{{ $t("app.adjustmentApplication") }}</el-button
            >
          </template>
        </el-table-column>
        <template v-for="col in column">
          <el-table-column
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
          >
            <template slot-scope="scope">
              <template
                v-if="
                  col.model === 'nameEnglish' ||
                    col.model === 'otherName' ||
                    col.model === 'nameChina'
                "
              >
                <div style="word-break: normal" @click="visibleStu(scope.row)">
                  {{ scope.row[col.model] }}
                </div>
              </template>
              <tempalate
                v-else-if="
                  col.model == 'checkOutDate' && scope.row['isExpireCheckOut']
                "
              >
                <div style="color: red; font-weight: bolder">
                  {{ scope.row[col.model] }}
                </div>
              </tempalate>
              <template v-else>
                {{ scope.row[col.model] }}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
    <el-dialog
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="visible"
      width="1000px"
      :title="$t('app.details')"
    >
      <el-tabs v-model="activeName" lazy>
        <el-tab-pane label="学生信息" name="stuInfo">
          <div style="height: 500px">
            <el-form style="height: 100%; overflow: auto" class="scroll-bar">
              <el-col
                :span="12"
                v-for="(i, index) in stuInfo"
                :key="index"
                style="height: 40px; padding: 0 15px"
              >
                <el-form-item
                  :label="index"
                  style="position: relative"
                  v-if="
                    index !== 'applyCheckOutDate' &&
                      index !== 'reasonOfLateToCheckOut' &&
                      index !== 'applyResult'
                  "
                >
                  <el-input
                    v-model="stuInfo[index]"
                    style="width: 240px; float: right"
                    size="small"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="退宿信息"
          name="checkOut"
          v-if="stuNumber"
          class="check-out-info"
        >
          <el-form>
            <div class="person-info clearfix" style="margin-bottom: 20px">
              <h3>{{ $t("app.personalInfo") }}</h3>
              <el-divider></el-divider>
              <el-col :span="12">
                <el-form-item :label="$t('app.studentIDNo')">
                  <el-input v-model="stuInfo.studentId" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$t('app.nameEnglish')"
                  prop="nameEnglish"
                  ref="nameEnglish"
                >
                  <el-input v-model="stuInfo.fullName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('app.chineseName')">
                  <el-input v-model="stuInfo.chineseName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('app.contactNo')">
                  <el-input v-model="stuInfo.telHome" disabled></el-input>
                </el-form-item>
              </el-col>
            </div>
            <div class="application-form">
              <h3>{{ $t("app.residentialInformation") }}</h3>
              <el-divider></el-divider>
              <el-form-item :label="$t('app.hostelRoomNo')">
                <el-input v-model="stuInfo.hostelRoom" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('app.expectedCheckoutDate')">
                <el-input
                  v-model="stuInfo.applyCheckOutDate"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('app.reasonForLateCheckout')">
                <el-input
                  type="textarea"
                  v-model="stuInfo.reasonOfLateToCheckOut"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="申請結果">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model="stuInfo.applyResult"
                  disabled
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="visible = false">{{
          $t("app.confirm")
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="batchVisible"
      width="500px"
      title="批量CheckIn"
    >
      <el-row
        v-if="
          multipleSelection.filter((_) => _.studentNumber && !_.hasCheckIn)
            .length < 1
        "
      >
        沒有需Checkin學生
      </el-row>
      <el-row v-else style="font-weight: bold">
        <el-col :span="6">房間號</el-col>
        <el-col :span="6">床位</el-col>
        <el-col :span="12">學生編號</el-col>
      </el-row>
      <el-row
        style="margin-top: 5px"
        v-for="i in multipleSelection.filter(
          (_) => _.studentNumber && !_.hasCheckIn
        )"
        :key="i.studentNumber"
      >
        <el-col :span="6">{{ i.room }}</el-col>
        <el-col :span="6">{{ i.bed }}</el-col>
        <el-col :span="12">{{ i.studentNumber }}</el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchCheckIn" size="small">{{
          $t("app.confirm")
        }}</el-button>
        <el-button type="info" @click="batchVisible = false" size="small">{{
          $t("app.cancel")
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="batchOutVisible"
      width="500px"
      title="批量退宿"
    >
      <el-row
        v-if="multipleSelection.filter((_) => _.studentNumber).length < 1"
      >
        沒有需退宿學生
      </el-row>
      <div v-else>
        <el-date-picker
          v-model="checkOutTime"
          format="yyyy-MM-dd HH:mm"
          type="datetime"
          placeholder="選擇退宿時間"
          size="small"
          style="margin-bottom: 1rem"
        >
        </el-date-picker>
        <el-row style="font-weight: bold">
          <el-col :span="6">房間號</el-col>
          <el-col :span="6">床位</el-col>
          <el-col :span="12">學生編號</el-col>
        </el-row>
        <el-row
          style="margin-top: 5px"
          v-for="i in multipleSelection.filter((_) => _.studentNumber)"
          :key="i.studentNumber"
        >
          <el-col :span="6">{{ i.room }}</el-col>
          <el-col :span="6">{{ i.bed }}</el-col>
          <el-col :span="12">{{ i.studentNumber }}</el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchCheckOut" size="small">{{
          $t("app.confirm")
        }}</el-button>
        <el-button type="info" @click="batchOutVisible = false" size="small">{{
          $t("app.cancel")
        }}</el-button>
      </span>
    </el-dialog>
    <!--批量設置床位標籤彈窗開始 -->
    <el-dialog
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="batchSetBedTagsVisible"
      width="500px"
      style="height: 500px"
      title="批量設置床位標籤"
    >
      <el-row>
        <el-col :span="24" style="margin-bottom: 15px"
          >設置標籤：
          <el-cascader
            size="small"
            :show-all-levels="false"
            :clearable="true"
            v-model="selectOpt"
            :placeholder="$t('app.validation.select')"
            :props="props"
            @change="adjustInfo"
            @expand-change="getParent"
            @visible-change="closeSelect"
          >
            <template slot-scope="{ node, data }">
              <span
                v-if="node.isLeaf"
                style="
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 3px;
                transform: scale(1.5);
                margin-right: 10px;
              "
                :style="{ backgroundColor: data.value.split('***')[1] }"
              >
              </span>
              <span>{{ data.label }}</span>
              <div
                v-if="
                  node.isLeaf &&
                    data.value.split('***')[2] &&
                    data.value.split('***')[2] !== 'null'
                "
                style="
                display: inline-block;
                position: relative;
                margin-left: 30px;
              "
              >
                <em
                  class="el-icon-s-custom"
                  @mouseenter="showStu(data.value.split('***')[2])"
                ></em>
              </div>
            </template>
          </el-cascader>
          <el-button
            size="small"
            type="primary"
            @click="handleEmpty"
            style="margin-left: 10px;"
            >確認</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
    <!--批量設置床位標籤彈窗結束 -->
    <adjust-modal ref="adjustModal" @adjustSuccess="getList"></adjust-modal>
    <check-out-modal
      ref="checkOutModal"
      @checkOutSuccess="getList"
    ></check-out-modal>
    <check-in-modal
      ref="checkInModal"
      @checkInSuccess="getList"
    ></check-in-modal>
    <details-modal ref="detailsModal"></details-modal>
  </div>
</template>

<script>
import ColorList from "@/components/tools/ColorCheckList";
import AdjustModal from "./modules/AdjustModal";
import CheckOutModal from "./modules/CheckOutModal";
import DetailsModal from "./modules/DetailsModal";
import CheckInModal from "./modules/CheckInModal";
import {
  getList,
  getRoomColor,
  getBedColor,
  getPersonColor,
  getInfo,
  batchCheckIn,
  batchCheckOut,
  batchSetBedTags,
} from "@/api/dormitoryManagement/list";
import { getFloorList } from "@/api/systemManagement/roomManagement";
import {
  getPageList,
  GetChildrent,
} from "@/api/systemManagement/bedTagsManagement";
export default {
  components: {
    AdjustModal,
    CheckOutModal,
    DetailsModal,
    ColorList,
    CheckInModal,
  },
  data() {
    return {
      checkOutTime: "",
      batchOutVisible: false,
      batchVisible: false,
      batchSetBedTagsVisible: false,
      stuInfo: {},
      activeName: "stuInfo",
      visible: false,
      applyNumber: "",
      stuNumber: "",
      searchInput: [
        { model: "roomCode", label: this.$t("app.roomCode") },
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        { model: "name", label: this.$t("app.name") },
        { model: "contact", label: this.$t("app.contactInformation") },
      ],
      column: [
        { model: "room", label: this.$t("app.room") },
        { model: "bed", label: this.$t("app.bed") },
        { model: "bedTagsName", label: this.$t("app.bedTages") },
        { model: "otherName", label: this.$t("app.otherName") },
        { model: "nameEnglish", label: this.$t("app.nameEnglish") },
        { model: "nameChina", label: this.$t("app.nameChina") },
        { model: "gender", label: this.$t("app.gender") },
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        {
          model: "contactInformation",
          label: this.$t("app.contactInformation"),
        },
        {
          model: "checkOutDate",
          label: this.$t("app.checkoutDate"),
        },
      ],
      colorList: [],
      colorListSecond: [],
      colorListThird: [],
      search: {
        roomCode: "",
        studentNumber: "",
        applyCode: "",
        name: "",
        contact: "",
        floorList: [],
        roomType: [],
        bed: [],
        person: [],
        isCheckIn: false,
        isCheckOutExpired: false,
        BedTagsld: "",
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
      floorList: [],
      multipleSelection: [],
      submitting: false,
      selectSort: "0",
      floorSort: [
        {
          value: "0",
          label: this.$t("app.ascOrder"),
        },
        {
          value: "1",
          label: this.$t("app.descOrder"),
        },
      ],
      selectOpt: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, value } = node;
          if (level === 0) {
            getPageList({ IsUse: true }).then((res) => {
              const nodes = res.data.Items.map((item) => ({
                value: item.Id,
                label: item.SchoolYear,
                leaf: false,
              }));
              resolve(nodes);
            });
          }
          if (level === 1) {
            this.roomList = {};
            console.log("###########value: " + value);
            GetChildrent({ pid: value }).then((res) => {
              /*
              const nodes = res.data.map(item => {
                this.roomList[item.RoomIndex] = item.BedGroup.map((items) => {
                  return {
                    value:
                      items.BedCode +
                      "***" +
                      items.BedStateColor +
                      "***" +
                      JSON.stringify(items.Student),
                    label: items.BedCode,
                    leaf: true,
                  };
                });
                return {
                  value: item.RoomIndex,
                  label: item.RoomIndex,
                  leaf: false,
                };
              });
              */
              const nodes = res.data.map((item) => ({
                value: item.Id,
                label: item.Name,
                leaf: true,
              }));
              resolve(nodes);
            });
          }
          if (level === 2) {
            console.log("#######value@@@@: " + value);
            // setTimeout(() => {
            //   const nodes = this.roomList[value].map((item) => ({
            //     value: item.value,
            //     label: item.label,
            //     leaf: true
            //   }));
            //   resolve(nodes);
            // }, 0);
          }
        },
      },
      bbprops: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, value } = node;
          if (level === 0) {
            getPageList({ IsUse: true }).then((res) => {
              const nodes = res.data.Items.map((item) => ({
                value: item.Id,
                label: item.SchoolYear,
                leaf: false,
              }));
              resolve(nodes);
            });
          }
          if (level === 1) {
            this.roomList = {};
            console.log("###########value: " + value);
            GetChildrent({ pid: value }).then((res) => {
              const nodes = res.data.map((item) => ({
                value: item.Id,
                label: item.Name,
                leaf: true,
              }));
              resolve(nodes);
            });
          }
          if (level === 2) {
            console.log("#######value@@@@: " + value);
          }
        },
      },
    };
  },
  created() {
    this.init();
  },
  computed: {
    isKeep() {
      return this.info.isContinueSameRoom
        ? this.info.isContinueSameRoom.split(",")
        : [];
    },
    selectList() {
      return this.multipleSelection.map((_) => _.studentNumber);
    },
  },
  methods: {
    // 批量插入床位确认按钮
    async handleEmpty() {
      console.log(this.multipleSelection);
      let BedIds = this.multipleSelection.map((item) => item.BedId);
      let param = {
        BedIds: BedIds.join(","),
        BedTagsId: this.selectOpt[this.selectOpt.length - 1],
      };
      console.log(param);
      const data = await batchSetBedTags(param);
      if (data.data) {
        this.$message({
          message: data.message,
          type: "success",
        });
        this.batchSetBedTagsVisible = false;
        this.init();
      } else {
        this.$message({
          message: data.message,
          type: "error",
        });
      }
      console.log(data);
    },
    // 全选方法
    adjustInfo(row) {
      console.log(row);
    },
    getParent(row) {
      console.log("getParent", row);
    },
    closeSelect(row) {
      console.log("关闭选择：", row);
    },
    visibleStu(obj) {
      this.visible = true;
      this.applyNumber = obj.applyCode || "";
      this.stuNumber = obj.studentNumber || "";
      if (!obj.studentNumber) {
        return;
      }
      getInfo({ studentCode: obj.studentNumber }).then((res) => {
        this.stuInfo = res.data;
      });
    },
    checkIn(row) {
      if (!row.studentNumber) {
        this.$message({
          message: "請選擇有學生的宿舍",
          type: "warning",
        });
        return;
      }
      this.$refs.checkInModal.edit(row);
    },
    init() {
      Promise.all([
        this.getRoomColor(),
        this.getBedColor(),
        this.getColor(),
        this.getFloor(),
      ]).then(() => {
        this.selectAll();
        this.getList();
      });
    },
    selectAll() {
      this.search.floorList = this.floorList.map((item) => {
        return item.code;
      });
      this.search.roomType = this.colorList.map((item, index) => {
        return (index + 1).toString();
      });
      this.search.bed = this.colorListSecond.map((item, index) => {
        return (index + 1).toString();
      });
    },
    selectReverse() {
      this.search.floorList = this.floorList
        .map((item) => {
          return item.code;
        })
        .filter((_) => this.search.floorList.findIndex((i) => i === _) < 0);
    },
    getFloor() {
      return new Promise((resolve, reject) => {
        getFloorList()
          .then((res) => {
            this.floorList = res.data
              .sort((a, b) => a.FloorCode - b.FloorCode)
              .map((item) => {
                return {
                  code: item.FloorCode,
                  name: item.FloorName,
                };
              });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getRoomColor() {
      return new Promise((resolve, reject) => {
        getRoomColor()
          .then((res) => {
            this.colorList = res.data.map((item) => {
              return {
                code: item.Code,
                text: item.Text,
                color: item.Color,
              };
            });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getBedColor() {
      return new Promise((resolve, reject) => {
        getBedColor()
          .then((res) => {
            this.colorListSecond = res.data.map((item) => {
              return {
                code: item.Code,
                text: item.Text,
                color: item.Color,
              };
            });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getColor() {
      return new Promise((resolve, reject) => {
        getPersonColor()
          .then((res) => {
            this.colorListThird = res.data.map((item) => {
              return {
                code: item.Code,
                text: item.Text,
                color: item.Color,
              };
            });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getList() {
      getList({
        ContactMobile: this.search.contact,
        RoomIndex: this.search.roomCode,
        Name: this.search.name,
        StudentCode: this.search.studentNumber,
        ApplicationCode: this.search.applyCode,
        PageIndex: this.currentPage,
        PageSize: this.size,
        Floor: this.search.floorList.join(","),
        RoomType: this.search.roomType.join(","),
        BedState: this.search.bed.join(","),
        StudentType: this.search.person.join(","),
        IsCheckIn: this.search.isCheckIn ? "1" : "",
        IsCheckOutExpired: this.search.isCheckOutExpired ? "1" : "",
        FloorSort: this.selectSort,
        BedTagsId:
          this.search.BedTagsld && this.search.BedTagsld.length > 0
            ? this.search.BedTagsld[this.search.BedTagsld.length - 1]
            : "",
      }).then((res) => {
        if (
          res.data == null ||
          res.data === undefined ||
          res.data.Items === null
        ) {
          this.tableData = [];
          this.total = 0;
          return;
        }
        this.total = res.data.Total;
        this.tableData = res.data.Items.map((item) => {
          return {
            room: item.RoomIndex,
            bed: item.Bed,
            bedTages: item.BedTages,
            nameEnglish: item.FullName,
            nameChina: item.ChineseName,
            gender: item.Gender,
            studentNumber: item.StudentCode,
            applicationNumber: item.ApplicationCode,
            contactInformation: item.ContactMobile,
            status: item.FeeState,
            requirement: item.HaveChangeRequirement,
            roomColor: item.RoomTypeColor,
            bedColor: item.BedStateColor,
            personColor: item.SpecialTypeColor,
            checkOutDate: item.CheckOutDate,
            hasCheckIn: item.HasCheckIn,
            otherName: item.OtherName,
            isExpireCheckOut: item.IsExpireCheckOut,
            bedTagsName: item.BedTagsName,
            ...item,
          };
        });
      });
    },
    reset() {
      this.search.roomCode = "";
      this.search.studentNumber = "";
      this.search.applyCode = "";
      this.search.name = "";
      this.search.contact = "";
      this.search.isCheckIn = false;
      this.search.isCheckOutExpired = false;
      this.search.roomType = [];
      this.search.bed = [];
      this.search.person = [];
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    adjust(row) {
      this.$refs.adjustModal.edit(row);
    },
    adjustApplication(row) {
      this.$refs.detailsModal.edit(row);
    },
    checkOut(row) {
      this.$refs.checkOutModal.edit(row);
    },
    cellStyle(row) {
      let color = "";
      if (row.column.property) {
        if (row.column.property === "room") {
          color = row.row.roomColor;
        } else if (row.column.property === "bed") {
          color = row.row.bedColor;
        } else {
          color = row.row.personColor;
        }
      }
      return {
        background: color,
      };
    },
    tableRowClassName({ row }) {
      if (row.isExpireCheckOut) {
        return "dormitory-list-warning-row";
      } else {
        return "";
      }
    },
    batchCheckIn() {
      const that = this;
      that.submitting = true;
      const studentGroup = this.multipleSelection
        .filter((_) => _.studentNumber)
        .map((_) => _.studentNumber);
      batchCheckIn({
        StudentCode: studentGroup,
      })
        .then((res) => {
          this.$message({
            message: "入住成功",
            type: "success",
          });
          that.submitting = false;
          that.batchVisible = false;
          this.getList();
        })
        .catch((error) => {
          that.submitting = false;
        });
    },
    batchCheckOut() {
      const that = this;
      that.submitting = true;
      const studentGroup = this.multipleSelection
        .filter((_) => _.studentNumber)
        .map((_) => _.studentNumber);
      batchCheckOut({
        StudentCode: studentGroup,
        CheckOutDate: this.checkOutTime,
      })
        .then((res) => {
          this.$message({
            message: "退宿成功",
            type: "success",
          });
          that.submitting = false;
          that.batchOutVisible = false;
          this.getList();
        })
        .catch((error) => {
          that.submitting = false;
        });
    },
    updateRoomType(value) {
      this.search.roomType = value;
    },
    updateBed(value) {
      this.search.bed = value;
    },
    updatePerson(value) {
      this.search.person = value;
    },
    sortChange() {
      this.getList();
    },
    searchData() {
      this.currentPage = 1;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.dormitory-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 80px);
  .table-container {
    height: calc(100% - 250px);
    overflow: auto;
  }
}
.check-out-info {
  .person-info,
  .application-form,
  .date-content {
    .el-form-item__content {
      padding: 0 15px;
    }
    .el-input {
      width: 300px;
    }
    .el-radio {
      margin-bottom: 6px;
    }
  }
}
.title {
  font-size: 14px;
  margin-right: 20px;
  margin-bottom: 20px;
}
</style>
<style>
.dormitory-list-warning-row {
  color: red;
}
</style>
